<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Button from 'primevue/button'
import { themeMode, toggleThemeMode } from '@/theme/mode'

/**
 * The light / dark switch beside the language switch, in the console's top bar
 * and in the public site's header. It shows the theme it turns on: the moon in
 * the light theme, the sun in the dark one.
 */
const { t } = useI18n()

const dark = computed(() => themeMode.value === 'dark')
const label = computed(() => t(dark.value ? 'nav.themeLight' : 'nav.themeDark'))
</script>

<template>
  <Button
    :icon="dark ? 'pi pi-sun' : 'pi pi-moon'"
    severity="secondary"
    text
    size="small"
    :aria-label="label"
    :title="label"
    :aria-pressed="dark"
    @click="toggleThemeMode"
  />
</template>
